import React, { Suspense } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  Flex,
  InputField,
  Snackbar,
  Typography
} from "../../../ppui";
import ErrorBoundary from "../../../utils/error-boundary";
import {
  ContentHeading,
} from "../../style";
import { HOLIDAY_INPUT_FIELDS } from "./holiday-constant";
import HolidayList from "./holiday-list";
import useHolidayService from "./use-holiday-service";

function HolidayManagement() {
  const {
    open,
    handleClickOpen,
    handleClose,
    handleSubmitFn,
    getInputFieldPropsFn,
    hanldeAddAnotherFn,
    addAnother,
    resource,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    handleEditModalOpen,
    deleteHoliday,
    holidayInputs,
  } = useHolidayService();


  return (
    <>
      <ContentHeading>
        <Typography variant="h5" mb="0">
          Holiday Management
        </Typography>

        <Button color="primary" variant="outlined" size="sm" onClick={handleClickOpen}>
          Add Holiday
        </Button>
      </ContentHeading>
      <Flex gap={20} direction={"column"}>
        <ErrorBoundary
          fallback={<p>Something went wrong in fetching BankList...</p>}
        >
          <Suspense fallback={<p>Loading Holiday...</p>}>
            <HolidayList resource={resource} handleEditModalOpen={handleEditModalOpen} deleteHoliday={deleteHoliday}/>
          </Suspense>
        </ErrorBoundary>
      </Flex>



      {/* Modal */}
      <Dialog
        title={`${holidayInputs?.holidayId ? "Update" : "Create"} Holiday`}
        closeButton={true}
        fullWidth
        maxWidth="xs"
        buttonName={"Save"}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmitFn}
        separator
        footer={
          !holidayInputs?.holidayId && <Box mr={"auto"}>
            <Checkbox
              size="sm"
              color="primary"
              label="Another Holiday"
              onChange={hanldeAddAnotherFn}
              checked={addAnother}
            />
          </Box>
        }
      >
        <Flex direction="column" width={"100%"} gap={"20"}>
          <InputField

            {...getInputFieldPropsFn(HOLIDAY_INPUT_FIELDS.holidayName.name)}

          />

          <InputField

            {...getInputFieldPropsFn(HOLIDAY_INPUT_FIELDS.holidayDate.name)}


          />


        </Flex>
      </Dialog>
      {/* Modal */}

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  );
}

export default HolidayManagement;
